import React from 'react'
import PropTypes from 'prop-types'
import ScholarshipSvg from 'components/atoms/SVGIcons/Scholarship'
import Paperplane from 'components/atoms/SVGIcons/Paperplane'
import { NavItem, NavLink, SVGIcon, Image, Badge } from 'components/qstrap'

const MobileMenuItem = ({
  icon, href, text, isNew, onClick,
}) => {
  let Icon

  if (icon === 'scholarship') {
    Icon = <ScholarshipSvg fill="#fff" className="icon-nav icon-align-middle m-r-md" />
  } else if (icon === 'paperplane') {
    Icon = <Paperplane fill="#fff" className="icon-nav icon-align-middle m-r-md" />
  } else if (/\/|\./.test(icon)) {
    Icon = <Image src={icon} className="icon-nav icon-align-middle m-r-md" />
  } else {
    Icon = <SVGIcon className="icon-nav icon-align-middle m-r-md" name={icon} />
  }

  return (
    <NavItem>
      <NavLink href={href || 'javascript:void(0)'} onClick={onClick}>
        <SVGIcon className="pull-right" name={href ? 'next' : ''} />
        {Icon}
        <span>{text}</span>
        {isNew && <Badge className="new-badge alt">NEW!</Badge>}
      </NavLink>
    </NavItem>
  )
}

MobileMenuItem.propTypes = {
  icon: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string,
  isNew: PropTypes.bool,
  onClick: PropTypes.func,
}

MobileMenuItem.defaultProps = {
  isNew: false,
}

export default MobileMenuItem
